/*
  DigiDispo — Hears-opbouw op Refresh (Claude, 13 okt 2026).
  Eén keer geladen, alle handlers gedelegeerd op document, zodat ze blijven werken nadat Refresh
  de winkelmand opnieuw opbouwt.
  1. Toevoegen aan winkelmand vanuit add-ons en mand-upsells  [data-dd-add]
  2. "All add-ons" uitklappen                                 [data-dd-addons-more]
  3. Vraagknoppen                                             .dd-q__chip
  4. Sliders: volgende-knop                                    [data-dd-next]
  5. Klantvideo's: tik = afspelen/pauze                        [data-dd-video]
  6. Vaste koopknop onderin op mobiel                          #DdStickyAtc
  7. Label per themavariant op de winkelwagen (_pdp_layout)    window.DD_LAYOUT
*/
(function () {
  if (window.__ddHears) return;
  window.__ddHears = true;

  var rawFetch = window.__kachingBundlesRawFetch || window.fetch.bind(window);

  /* ---------- helpers ---------- */
  function cartDrawer() { return document.querySelector('cart-drawer'); }

  function sectionsToRender() {
    var cd = cartDrawer();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addToCart(variantId) {
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionsToRender().join(','),
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- 1. toevoegen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dd-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');
    var vid = btn.getAttribute('data-dd-add');
    addToCart(vid)
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || 'add failed');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = btn.getAttribute('data-dd-added-label') || 'Added';
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dd-add', productVariantId: vid, cartData: res }); } catch (err) {}
        }
        var cd = cartDrawer();
        if (document.querySelector('cart-items') && !cd) { window.location.reload(); return; }
        if (cd && res.sections) {
          cd.renderContents({ id: Number(vid), sections: res.sections });
        }
        setTimeout(ddTagCart, 800);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* ---------- 2. alle add-ons ---------- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-dd-addons-more]');
    if (!more) return;
    var wrap = more.closest('[data-dd-addons]');
    if (!wrap) return;
    wrap.querySelectorAll('.dd-addon--more').forEach(function (el) { el.hidden = false; });
    more.setAttribute('aria-expanded', 'true');
    more.hidden = true;
  });

  /* ---------- 3. vraagknoppen ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.dd-q__chip');
    if (!chip) return;
    var ans = document.getElementById(chip.getAttribute('aria-controls'));
    if (!ans) return;
    var open = chip.getAttribute('aria-expanded') === 'true';
    chip.setAttribute('aria-expanded', open ? 'false' : 'true');
    ans.hidden = open;
  });

  /* ---------- 4. sliders ---------- */
  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-dd-next]');
    if (!next) return;
    var slider = next.closest('[data-dd-slider]');
    var track = slider && slider.querySelector('[data-dd-scroller]');
    if (!track) return;
    var item = track.firstElementChild;
    var step = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
  });

  /* ---------- 5. klantvideo's ---------- */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-dd-video]');
    if (!card) return;
    var v = card.querySelector('video');
    if (!v) return;
    document.querySelectorAll('[data-dd-video] video').forEach(function (o) {
      if (o !== v) { o.pause(); o.closest('[data-dd-video]').classList.remove('is-playing'); }
    });
    if (v.paused) { v.muted = false; v.play(); card.classList.add('is-playing'); }
    else { v.pause(); card.classList.remove('is-playing'); }
  });

  /* ---------- 6. vaste koopknop ---------- */
  function initSticky() {
    var wrap = document.getElementById('DdStickyAtc');
    if (!wrap) return;
    var main = document.querySelector('product-info button[name="add"].product-form__submit, product-info button[name="add"]');
    if (!main) return;
    if (wrap.parentElement !== document.body) document.body.appendChild(wrap);
    wrap.hidden = false;
    var btn = wrap.querySelector('button');
    var label = wrap.querySelector('.dd-sticky-atc__label');

    function sync() {
      var t = main.querySelector('span:not(.hidden)');
      if (t && t.textContent.trim()) label.textContent = t.textContent.trim();
      btn.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
    }
    function update() {
      var gone = main.getBoundingClientRect().bottom < 0;
      var cd = cartDrawer();
      var drawerOpen = cd && cd.classList.contains('active');
      var show = gone && !drawerOpen && window.innerWidth < 750;
      wrap.classList.toggle('is-visible', show);
      wrap.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    btn.addEventListener('click', function () {
      if (main.disabled) return;
      main.click();
    });
    sync(); update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    try {
      new MutationObserver(function () { sync(); update(); }).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
      var cd = cartDrawer();
      if (cd) new MutationObserver(update).observe(cd, { attributes: true, attributeFilter: ['class'] });
    } catch (err) {}
  }

  /* ---------- 7. label per themavariant ---------- */
  var tagBusy = false;
  function ddTagCart() {
    var value = window.DD_LAYOUT;
    if (!value || tagBusy) return;
    tagBusy = true;
    rawFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        if (cart.attributes && cart.attributes._pdp_layout === value) return;
        return rawFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _pdp_layout: value } })
        });
      })
      .catch(function () {})
      .then(function () { tagBusy = false; });
  }
  window.ddTagCart = ddTagCart;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], .dd-sticky-atc__btn')) setTimeout(ddTagCart, 2500);
  }, true);

  function init() {
    initSticky();
    ddTagCart();
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(ddTagCart, 1200); });
      }
    } catch (err) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
